<template lang="pug">
.my-router-link(@click="onClick")
  slot
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'MyRouterLink',
  props: {
    from: {},
    to: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onClick() {
      this.setRouterBack(this.from)
      this.$router.replace(this.to)
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
</style>
